import Image from './image'

export default class Goal {
  readonly id: number
  readonly name: string
  readonly description: string
  readonly body: string
  readonly image: Image

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.name = data.name
    this.description = data.description
    this.body = data.body
    this.image = data.image

    if (data.image) {
      this.image = new Image(data.image)
    }
  }
}
